import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Chip, Button, Typography } from '@material-ui/core';
import dayjs from 'dayjs';

import KPTable from '../../../../components/KPTComponents/KPTable';
import PopupMenu from '../../../../components/CustomComponents/PopupMenu';
import PreviewModal from '../../../../components/CustomComponents/PreviewModal';
import DuyetThanhTichModal from '../../../../components/CustomComponents/DuyetThanhTichModal';
import { TECH_COMPANY_CONSTANTS } from '../../../../constants';
import DoanhNghiepUpdate from '../DoanhNghiepUpdate/DoanhNghiepUpdate';
import { techCompanyActions } from '../../../../actions';
import { resolveQcvLabel } from '../../../../utils/qcvScoreOptions';

export default function DoanhNghiepTable(props) {
  const dispatch = useDispatch();
  const scoreInformationList = useSelector(
    (state) => state.scoreInformationReducer.scoreInformationList
  );
  const loading = useSelector(state => state.techCompanyReducer.loading);
  const totalTechCompanyList = useSelector(state => state.techCompanyReducer.totalTechCompanyList);
  const personalTechCompanyList = useSelector(state => state.techCompanyReducer?.personalTechCompanyList);
  const { productionOptions } = TECH_COMPANY_CONSTANTS;
  const [values, setValues] = useState(null);
  const [duyetThanhTich, setDuyetThanhTich] = useState(null);

  const [detail, setDetail] = useState(null);
  const [preview, setPreview] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteMenuAnchor, setDeleteMenuAnchor] = useState(false);
  const [list, setList] = useState(null)
  const [totalList, setTotalList] = useState(null);

  useEffect(() => {
    if (personalTechCompanyList) {
      setList(personalTechCompanyList.map(param => ({
        ...param,
        decisionDay: dayjs(param.decisionDay).format('DD/MM/YYYY')
      })))
    }
    if (totalTechCompanyList) {
      setTotalList(totalTechCompanyList.map(param => ({
        ...param,
        decisionDay: dayjs(param.decisionDay).format('DD/MM/YYYY')
      })))
    }
  }, [personalTechCompanyList, totalTechCompanyList]);

  const openDeleteMenu = (e, id) => {
    setDeleteId(id);
    setDeleteMenuAnchor(e.currentTarget);
  }

  const closeDeleteMenu = () => {
    setDeleteId(null);
    setDeleteMenuAnchor(null);
  }

  // const handleAccepted = (row) => {
  //   dispatch(techCompanyActions.updateTechCompanyAccepted({ id: row.id, accepted: !row.accepted }));
  // }

  const handleAccepted = (row = duyetThanhTich) => {
    dispatch(techCompanyActions.updateTechCompanyAccepted(
      [{
        id: row.formTechCompanyId,
        accepted: !row.thanhTichAccepted,
        score: values?.score || 0,
        note: values?.note || '',
      }]
    ));
    setDuyetThanhTich(null);
    setValues(null);
  }

  const handleDelete = () => {
    dispatch(techCompanyActions.deleteTechCompany(deleteId));
    closeDeleteMenu();
  }

  const mobileMode = window.innerWidth <= 768;

  // const tableRows = props.filterType === 'person' ? list : totalList;
  var tableRows = [];
  if (props?.rows) {
    tableRows = props?.rows;
  } else {
    tableRows = props.filterType === 'person' ? list : totalList;
  }

  var columns = [
    { title: <b>STT</b>, dataIndex: 'id', width: '5%', render: (_, row, id) => id + 1 },
    {
      title: <b>Tên sản phẩm</b>,
      dataIndex: 'production',
      width: props.type === 'update' ? '25%' : '30%',
      sorter: (a, b) => a?.production.localeCompare(b?.production),
    },
    {
      title: <b>Giá trị của sản phẩm</b>,
      dataIndex: 'value',
      width: '25%',
      render: (value) => `${value} VNĐ`,
    },
    {
      title: <b>Phạm vi ứng dụng</b>,
      dataIndex: 'applicationRange',
      width: '25%',
      render: (value) => resolveQcvLabel(scoreInformationList, '6', productionOptions, value),
    },
    {
      title: <b>Tình trạng</b>,
      dataIndex: 'thanhTichAccepted',
      width: '15%',
      filters: [
        { text: 'Đã được duyệt', value: true },
        { text: 'Chưa được duyệt', value: false }
      ],
      onFilter: (value, row) => row.thanhTichAccepted === value,
      render: (value) => (
        <Chip
          size='small'
          variant='outlined'
          color={value ? 'primary' : 'default'}
          label={`${value ? 'Đã' : 'Chưa'} duyệt`}
          style={{ width: '100%' }}
        />
      )
    },
    {
      title: <b>Tác vụ</b>,
      dataIndex: 'cc-actions',
      width: '15%',
      render: (_, row) => (
        <>
          <Typography variant='body2' color='primary' className='actions-button' onClick={() => setDetail(row)}>Chi tiết</Typography>
          {!(props.type === 'accept') && (
            <Typography
              variant='body2'
              color='secondary'
              className='actions-button'
              onClick={(e) => openDeleteMenu(e, row.id)}
            >
              Xoá
            </Typography>
          )}
          <Typography variant='body2' className='actions-button' onClick={() => setPreview(row?.link)}>Minh chứng</Typography>
          {(props.type === 'accept') && (
            <Typography
              variant='body2'
              color={row?.thanhTichAccepted ? 'secondary' : 'primary'}
              className='actions-button'
              onClick={() => {
                if (row?.thanhTichAccepted) handleAccepted(row); else setDuyetThanhTich(row);
              }}
            >
              {`${row?.thanhTichAccepted ? 'Huỷ xác' : 'Xác'} nhận`}
            </Typography>
          )}
        </>
      ),
    },
  ];

  if (props.type === 'accept') {
    columns = [
      { ...columns[0] },
      {
        title: <b>Thông tin thành tích</b>,
        dataIndex: 'title',
        width: '50%',
        render: (_, row) => (
          <>
            <Typography variant='body2'><b>Tên sản phẩm: </b>{row.production}</Typography>
            <Typography variant='body2'>
              <b>Giá trị(VND/1 năm): </b>
              {`${row.value?.toString().replace(/\D/g,'')?.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, '.')} VNĐ`}
            </Typography>
            <Typography variant='body2'>
              <b>Phạm vi ứng dụng: </b>
              {resolveQcvLabel(scoreInformationList, '6', productionOptions, row.applicationRange)}
            </Typography>
          </>
        ) 
      },
      { title: <b>Điểm</b>, dataIndex: 'score', width: '5%' },
      { title: <b>Ghi chú</b>, dataIndex: 'note', width: '15%' },
      { ...columns[4], width: '13%' },
      { ...columns[5], width: '12%' },
    ];
  }
  if (props.type === 'update') {
    if (mobileMode) {
      columns = [
        { ...columns[1], title: <b>Tiêu đề</b>, width: '45%' },
        { ...columns[3], width: '30%' },
        { ...columns[5], width: '25%' },
      ];
    } else {
      columns = [
        { ...columns[0], width: '5%' },
        { ...columns[1], width: '25%' },
        { ...columns[2], width: '25%' },
        { ...columns[3], width: '15%' },
        { ...columns[4], width: '15%' },
        { ...columns[5], width: '15%' },
      ];
    }
  }

  return (
    <Grid item xs={12}>
      <KPTable
        nonBorder={props.type === 'accept'}
        columns={columns}
        rows={tableRows}
        loading={loading}
      />

      <DoanhNghiepUpdate detail={detail} acceptMode={props.type === 'accept'} onClose={() => setDetail(null)} />

      <PopupMenu
        position='center'
        anchorEl={deleteMenuAnchor}
        handleClose={closeDeleteMenu}
        render={
          <div style={{ padding: 8 }}>
            <Typography style={{ paddingBottom: 16 }}>Xác nhận xoá thông tin giải thưởng?</Typography>
            <Button variant='outlined' style={{ width: 'calc(50% - 4px)' }} onClick={closeDeleteMenu}>Huỷ</Button>
            <Button variant='contained' color='secondary' style={{ marginLeft: 8, width: 'calc(50% - 4px)' }} onClick={handleDelete}>Xác nhận</Button>
          </div>
        }
      />

      <PreviewModal
        open={!!preview}
        url={preview}
        handleClose={() => setPreview(null)}
      />

      <DuyetThanhTichModal
        type='formTechCompany'
        info={duyetThanhTich}
        values={values}
        setValues={setValues}
        open={!!duyetThanhTich}
        handleClose={() => setDuyetThanhTich(null)}
        handleSubmit={handleAccepted}
      />
    </Grid>
  );
}